import '../styling/butterflies_loader.css';

export const Loader_Butterflies = () => {
    return (
        <div className='LoaderButterlies'>
            <div className='LoaderButterflies-Container'>
                <div className='LoaderButterflies-Butterfly LoaderButterflies-Butterfly_1'>
                    <div className='LoaderButterflies-Butterfly_wing LoaderButterflies-Butterfly_wing-left'></div>
                    <div className='LoaderButterflies-Butterfly_wing LoaderButterflies-Butterfly_wing-right'></div>
                    <div className='LoaderButterflies-Butterfly_body'></div>
                </div>

                <div className='LoaderButterflies-Butterfly LoaderButterflies-Butterfly_2'>
                    <div className='LoaderButterflies-Butterfly_wing LoaderButterflies-Butterfly_wing-left'></div>
                    <div className='LoaderButterflies-Butterfly_wing LoaderButterflies-Butterfly_wing-right'></div>
                    <div className='LoaderButterflies-Butterfly_body'></div>
                </div>

                <p className='LoaderButterflies-Text'>just a sec... </p>
                <p className='LoaderButterflies-Text'>I'm putting together some great quotes for you.</p>

                <div className='LoaderButterflies-Butterfly LoaderButterflies-Butterfly_3'>
                    <div className='LoaderButterflies-Butterfly_wing LoaderButterflies-Butterfly_wing-left'></div>
                    <div className='LoaderButterflies-Butterfly_wing LoaderButterflies-Butterfly_wing-right'></div>
                    <div className='LoaderButterflies-Butterfly_body'></div>
                </div>

                <div className='LoaderButterflies-Butterfly LoaderButterflies-Butterfly_4'>
                    <div className='LoaderButterflies-Butterfly_wing LoaderButterflies-Butterfly_wing-left'></div>
                    <div className='LoaderButterflies-Butterfly_wing LoaderButterflies-Butterfly_wing-right'></div>
                    <div className='LoaderButterflies-Butterfly_body'></div>
                </div>
            </div>
        </div>
    );
};
